import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'dateFormat',
    standalone: false
})
export class DateFormatPipe implements PipeTransform {
  transform(value: unknown, ...args: any[]): unknown {
    return moment(value).format(args[0]).split('/').join('.');
  }
}
